<template>
  <tr :key="value.id" @click="$emit('onDetails', value)">
    <td v-for="header in headers" :key="header.text">
      <v-tooltip v-if="header.key === 'Status'" location="bottom">
        <template #activator="{ props }">
          <v-chip :color="value.Status.color" v-bind="props" dark>
            {{ value.Status.name }}
          </v-chip>
        </template>
        <span>{{ value.Status.description }}</span>
      </v-tooltip>

      <v-tooltip v-else-if="header.key === 'Type'" location="bottom">
        <template #activator="{ props }">
          <img
            :src="value.Type.img"
            :alt="value.Type.description"
            width="40"
            height="40"
            v-bind="props"
          />
        </template>
        <span> {{ value.Type.name }}</span>
      </v-tooltip>

      <v-tooltip
        v-else-if="header.key === 'Website' && value.Website"
        location="bottom"
      >
        <template #activator="{ props }">
          <a
            v-bind="props"
            :href="value.Website.url"
            target="_blank"
            @click.stop
          >
            {{ value.Website.url }}
          </a>
        </template>
        <span>Open</span>
      </v-tooltip>

      <span v-else-if="header.key === 'CPM'">
        {{ formatPrice(value.Settings.cpm) }}
      </span>

      <span v-else-if="header.key === 'created_at'">
        {{ formatDates(value.created_at) }}
      </span>

      <div v-else-if="header.key === 'Views'">
        <v-sheet color="rgba(0, 0, 0, .0)">
          <v-sparkline
            :model-value="[423, 446, 675, 510, 590, 610, 760]"
            color="rgba(12, 90, 213, .7)"
            height="100"
            padding="24"
            stroke-linecap="round"
            smooth
          />
        </v-sheet>
      </div>

      <div v-else-if="header.key === 'Actions'">
        <v-tooltip location="bottom">
          <template #activator="{ props }">
            <v-btn
              v-bind="props"
              variant="text"
              icon
              color="primary"
              density="compact"
              @click="codeDialog = true"
            >
              <v-icon small>mdi-content-copy</v-icon>
            </v-btn>
          </template>
          <span>View & Copy Tag Code</span>
        </v-tooltip>

        <v-tooltip location="bottom">
          <template #activator="{ props }">
            <v-btn
              v-bind="props"
              variant="text"
              class="ml-2"
              icon
              color="error"
              density="compact"
              @click="deactivationDialog = true"
            >
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </template>
          <span>Deactivate</span>
        </v-tooltip>
        <v-dialog v-model="codeDialog" max-width="80%">
          <v-card>
            <v-card-title class="text-h5">Code Snippet</v-card-title>
            <v-card-text>
              <AdPlacementCodePreview :model-value="value.tag" />
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="codeDialog = false">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <ConfirmationDialog
          :model-value="deactivationDialog"
          icon="mdi-alert-rhombus-outline"
          type="warning"
          title="Deactivate Ad Placement"
          :message="`Are you sure you want to deactivate ${value.name} : ${value.resolution}?`"
          @confirm="
            $emit('onDelete', value.id);
            deactivationDialog = false;
          "
          @cancel="deactivationDialog = false"
        />
      </div>

      <AdPlacementHourlyImpressions
        v-else-if="header.key === 'Impressions'"
        :value="value"
      />
      <AdPlacementHourlyIdle v-else-if="header.key === 'Idle'" :value="value" />

      <span v-else>
        {{ value[header.key] }}
      </span>
    </td>
  </tr>
</template>


<script>
import moment from "moment";
import AdPlacementCodePreview from "../../molecules/adPlacement/AdPlacementCodePreview.vue";
import ConfirmationDialog from "../../molecules/common/ConfirmationDialog.vue";
import { FormatterHelper } from "@/helpers/formatter.helper";
import AdPlacementHourlyIdle from "../../molecules/adPlacement/analytics/AdPlacementHourlyIdle.vue";
import AdPlacementHourlyImpressions from "../../molecules/adPlacement/analytics/AdPlacementHourlyImpressions.vue";

export default {
  name: "InventoryItemTableItem",
  components: {
    AdPlacementCodePreview,
    ConfirmationDialog,
    AdPlacementHourlyIdle,
    AdPlacementHourlyImpressions,
  },
  inheritAttrs: false,
  props: {
    headers: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["onDetails", "onDelete"],
  data() {
    return {
      deactivationDialog: false,
      codeDialog: false,
    };
  },
  methods: {
    formatDates(date) {
      return moment(date).format("MMMM Do");
    },
    formatPrice(value) {
      return FormatterHelper.price(value / 100);
    },
    getStatus(item) {
      return item && item.Status && item.Status.code
        ? {
            text: item.Status.code,
            color: item.Status.color,
          }
        : {
            text: "Unknown",
            color: "grey",
          };
    },
  },
};
</script>